module.exports = __webpack_public_path__ + "static/media/42-5.c1847064.mp3";